export const PH_MOBILE_ERROR =
  'Please enter a valid Philippine mobile number (09XXXXXXXXX or +639XXXXXXXXX).';

const LOCAL_PATTERN = /^09\d{9}$/;
const INTERNATIONAL_PATTERN = /^\+639\d{9}$/;

export const normalizePhoneInput = (value) => String(value || '').trim();

export const isValidPhilippineMobile = (value) => {
  const phone = normalizePhoneInput(value);
  if (!phone) return false;
  return LOCAL_PATTERN.test(phone) || INTERNATIONAL_PATTERN.test(phone);
};

export const validatePhilippineMobile = (value, { required = false } = {}) => {
  const phone = normalizePhoneInput(value);
  if (!phone) {
    return required ? PH_MOBILE_ERROR : '';
  }
  return isValidPhilippineMobile(phone) ? '' : PH_MOBILE_ERROR;
};

/** Normalize accepted PH mobiles to +639XXXXXXXXX. Empty or invalid values are returned trimmed. */
export const normalizePhilippineMobile = (value) => {
  const phone = normalizePhoneInput(value);
  if (!phone || !isValidPhilippineMobile(phone)) return phone;
  if (LOCAL_PATTERN.test(phone)) return `+63${phone.slice(1)}`;
  return phone;
};

export const formatPhilippineMobileDisplay = (value) => {
  const phone = normalizePhoneInput(value);
  if (!phone) return '';
  const normalized = isValidPhilippineMobile(phone) ? normalizePhilippineMobile(phone) : phone;
  if (!INTERNATIONAL_PATTERN.test(normalized)) return phone;
  return `+63 ${normalized.slice(3, 6)} ${normalized.slice(6, 9)} ${normalized.slice(9)}`;
};
